import { CatalogDataResponseItem } from "../types";
import { getEssilorMagazinRawRowsData } from "./parse-variants-data";

const variantToParseFunctionMap = {
    'essilor-magazin': getEssilorMagazinRawRowsData,
    'essilor-prescription': getEssilorMagazinRawRowsData
}

export const getVariantRawRowsData = (data: CatalogDataResponseItem[], variant: string) => {
    console.log('initial data', data);
    if (!(variant in variantToParseFunctionMap)) {
        return []
    }
    const fuctionToCall = variantToParseFunctionMap[variant as keyof typeof variantToParseFunctionMap];

    return fuctionToCall(data);
}